<template>
  <div>
    <b-col cols="12" class="mb-4">
      <PageTitle title="Produtos mais comprados" />
    </b-col>

    <b-col cols="12" class="mb-4">
      <PeriodsFilters
        ref="periodsFilters"
        :setDatesAutomatic="false"
        :startDate.sync="startDate"
        :endDate.sync="endDate"
        @click.native="get()"
      />
    </b-col>

    <b-col cols="12">
      <h5 class="font-weight-bold">Status do pedido</h5>
      <div>
        <h4 class="d-flex align-items-center flex-wrap" style="gap: 10px">
          <b-badge
            :variant="
              status.includes(ORDER_STATUS.WAITING_PAYMENT)
                ? 'primary'
                : 'light'
            "
            class="pointer"
            @click="addStatus(ORDER_STATUS.WAITING_PAYMENT)"
          >
            {{ getOrderStatusText(ORDER_STATUS.WAITING_PAYMENT) }}
          </b-badge>

          <b-badge
            :variant="
              status.includes(ORDER_STATUS.SEPARATING_ORDER)
                ? 'primary'
                : 'light'
            "
            class="pointer"
            @click="addStatus(ORDER_STATUS.SEPARATING_ORDER)"
          >
            {{ getOrderStatusText(ORDER_STATUS.SEPARATING_ORDER) }}
          </b-badge>

          <b-badge
            :variant="status.includes(ORDER_STATUS.SENT) ? 'primary' : 'light'"
            class="pointer"
            @click="addStatus(ORDER_STATUS.SENT)"
          >
            {{ getOrderStatusText(ORDER_STATUS.SENT) }}
          </b-badge>

          <b-badge
            :variant="
              status.includes(ORDER_STATUS.READY_FOR_PICKUP)
                ? 'primary'
                : 'light'
            "
            class="pointer"
            @click="addStatus(ORDER_STATUS.READY_FOR_PICKUP)"
          >
            {{ getOrderStatusText(ORDER_STATUS.READY_FOR_PICKUP) }}
          </b-badge>

          <b-badge
            :variant="
              status.includes(ORDER_STATUS.DELIVERED) ? 'primary' : 'light'
            "
            class="pointer"
            @click="addStatus(ORDER_STATUS.DELIVERED)"
          >
            {{ getOrderStatusText(ORDER_STATUS.DELIVERED) }}
          </b-badge>

          <b-badge
            :variant="
              status.includes(ORDER_STATUS.CANCELED) ? 'primary' : 'light'
            "
            class="pointer"
            @click="addStatus(ORDER_STATUS.CANCELED)"
          >
            {{ getOrderStatusText(ORDER_STATUS.CANCELED) }}
          </b-badge>

          <b-badge
            :variant="
              status.includes(ORDER_STATUS.EXPIRED) ? 'primary' : 'light'
            "
            class="pointer"
            @click="addStatus(ORDER_STATUS.EXPIRED)"
          >
            {{ getOrderStatusText(ORDER_STATUS.EXPIRED) }}
          </b-badge>

          <b-badge
            :variant="
              status.includes(ORDER_STATUS.IN_ANALYSIS) ? 'primary' : 'light'
            "
            class="pointer"
            @click="addStatus(ORDER_STATUS.IN_ANALYSIS)"
          >
            {{ getOrderStatusText(ORDER_STATUS.IN_ANALYSIS) }}
          </b-badge>

          <b-badge
            :variant="
              status.includes(ORDER_STATUS.REPROVED) ? 'primary' : 'light'
            "
            class="pointer"
            @click="addStatus(ORDER_STATUS.REPROVED)"
          >
            {{ getOrderStatusText(ORDER_STATUS.REPROVED) }}
          </b-badge>

          <b-badge
            :variant="
              status.length === Object.keys(ORDER_STATUS).length
                ? 'primary'
                : 'light'
            "
            class="pointer"
            @click="addAllStatus()"
          >
            Todos
          </b-badge>
        </h4>
      </div>
    </b-col>

    <b-col cols="12" class="mt-4">
      <b-table
        striped
        hover
        responsive
        :fields="table.headers"
        :items="table.records"
        :busy="loading"
      >
        <template #table-busy>
          <div class="text-center my-2">
            <b-spinner class="align-middle mr-2"></b-spinner>
            <strong>Carregando...</strong>
          </div>
        </template>

        <template #cell(img)="data">
          <img
            :src="formatImg(data.item.img)"
            :alt="data.item.product"
            width="50px"
          />
        </template>

        <template #cell(product)="data">
          {{ data.item.product }}
        </template>

        <template #cell(bar_code)="data">
          {{ data.item.bar_code }}
        </template>

        <template #cell(cod_int)="data">
          {{ data.item.cod_int }}
        </template>

        <template #cell(total_sold)="data">
          {{ data.item.total_sold }}
        </template>
      </b-table>
    </b-col>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import PageTitle from '../../../components/PageTitle.vue';
import makeToast from '../../../mixins/makeToast';
import PeriodsFilters from '@/components/Inputs/PeriodsFilters.vue';
import ORDER_STATUS from 'Enums/Order/Status.js';
import UserTypes from '@/enums/UserTypes';

export default {
  name: 'ProductsBestSellers',
  mixins: [makeToast],
  components: {
    PageTitle,
    PeriodsFilters,
  },

  data() {
    return {
      loading: false,
      ORDER_STATUS,
      startDate: '',
      endDate: '',
      status: [],
      table: {
        headers: [
          { key: 'img', label: 'Foto', thStyle: { width: '70px' } },
          { key: 'product', label: 'Produto' },
          {
            key: 'bar_code',
            label: 'Cód. barras',
            thStyle: { width: '100px' },
          },
          { key: 'cod_int', label: 'Cód. int.', thStyle: { width: '100px' } },
          {
            key: 'total_sold',
            label: 'Qtd. comprada',
            thStyle: { width: '120px' },
          },
        ],
        records: [],
      },
    };
  },

  computed: {
    ...mapState(['dadosUsuario']),
  },

  mounted() {
    this.get();
  },

  methods: {
    ...mapActions('shopkeeper', ['getProductBestSellers']),

    get() {
      this.limpar = false;
      (this.loading = true), this.$store.dispatch('startLoader');

      const data = {
        construpUserId: this.userTypeId(),
        startDate: this.startDate,
        endDate: this.endDate,
        status: this.status,
      };

      this.getProductBestSellers(data)
        .then((response) => {
          this.table.records = response.data;
        })
        .finally(() => {
          this.loading = false;
          this.$store.dispatch('endLoader');
        });
    },
    formatImg(img) {
      return process.env.VUE_APP_FOTOS_URL + img;
    },
    addAllStatus() {
      Object.values(ORDER_STATUS).forEach((value) => {
        if (this.status.includes(value)) return;

        this.status.push(value);
      });

      this.get();
    },
    addStatus(userType) {
      if (this.status.includes(userType)) {
        const index = this.status.indexOf(userType);
        this.status.splice(index, 1);
        this.get();
        return;
      }

      this.status.push(userType);
      this.get();
    },
    userTypeId() {
      return this.$route.meta.userType == UserTypes.BALCONISTA
        ? this.dadosUsuario.construp_user_id
        : this.dadosUsuario.id;
    },
    getOrderStatusText(status) {
      const texts = {
        [ORDER_STATUS.WAITING_PAYMENT]: 'Aguardando pagamento',
        [ORDER_STATUS.SEPARATING_ORDER]: 'Separando pedido',
        [ORDER_STATUS.SENT]: 'Saiu para entrega',
        [ORDER_STATUS.READY_FOR_PICKUP]: 'Pronto para retirada',
        [ORDER_STATUS.DELIVERED]: 'Entregue',
        [ORDER_STATUS.CANCELED]: 'Cancelado',
        [ORDER_STATUS.EXPIRED]: 'Expirado',
        [ORDER_STATUS.IN_ANALYSIS]: 'Em análise',
        [ORDER_STATUS.REPROVED]: 'Reprovado',
      };

      return texts[status] || 'N/A';
    },
  },
};
</script>
